
import { Options, Vue } from "vue-class-component";
// @ts-ignore
import guest from "../data/guestData.js";
import { useRoute } from "vue-router";

@Options({
  props: {
    guestId: String,
  },
  methods: {
    formatYoutubeLink(link: string) {
      if (link && link.includes("user")) {
        const code = this.youtube?.slice(29);
        return `https://www.youtube.com/embed/?listType=user_uploads&list=${code}`;
      }
      if (link && link.includes("channel")) {
        const code = this.youtube?.slice(34, 56);
        return `https://www.youtube.com/embed/videoseries?list=UU${code}`;
      }
    },
  },
})
export default class Media extends Vue {
  route = useRoute();
  id = this.route.params.id;
  guest = guest.filter((guest: { _id: string }) => guest._id === this.id)?.[0];
  youtube?: string = this.guest.links?.youtubeChannel;
  spotify?: string = this.guest.links?.spotify;
  youtubeLink?: string | false =
    this.youtube?.includes("http") &&
    this.youtube?.includes("youtube.com") &&
    this.youtube?.length > 15 &&
    !this.youtube?.includes("/c/")
      ? this.youtube
      : false;
  spotifyLink?: string | false = this.spotify?.includes(
    "open.spotify.com/artist"
  )
    ? this.spotify?.slice(32, 54)
    : this.spotify?.includes("spotify:artist:")
    ? this.spotify?.slice(15, 37)
    : false;
}
